import { render, staticRenderFns } from "./PersonnelNavitem.vue?vue&type=template&id=08b7bfd0&scoped=true"
import script from "./PersonnelNavitem.vue?vue&type=script&lang=js"
export * from "./PersonnelNavitem.vue?vue&type=script&lang=js"
import style0 from "./PersonnelNavitem.vue?vue&type=style&index=0&id=08b7bfd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b7bfd0",
  null
  
)

export default component.exports